import { useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import userApi from "../../api/user/user.api";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import { setUser } from "../../redux/features/userSlice";
import { useNavigate } from "react-router-dom";
import ProcessingBar2 from "../ProcessingBar/ProcessingBar2";
import { Eye, EyeClosed } from "lucide-react";

const SigninForm = ({ switchAuthState }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoginRequest, setIsLoginRequest] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const signinForm = useFormik({
    initialValues: {
      password: "",
      username: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .min(3, "Username must be at least 3 characters")
        .required("Username is required"),
      password: Yup.string()
        .min(3, "Password must be at least 3 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setErrorMessage("");
      setIsLoginRequest(true);

      // let responseLogin = dispatch(login(values));
      const { response, err } = await userApi.signin(values);

      console.log({ response });
      console.log("error:", err);
      if (response) {
        signinForm.resetForm();
        setIsLoginRequest(false);
        dispatch(setUser(response.data));
        dispatch(setAuthModalOpen(false));

        toast.success("Sign in successful");

        setTimeout(() => {
          navigate("/ordering");
          window.location.reload();
        }, 100); // 1 second delay
      }

      if (err) setErrorMessage(err.message);
    },
  });

  const [showPassword, setShowPassword] = useState(false);

  return (
    <form onSubmit={signinForm.handleSubmit} className="space-y-4">
      {/* Username Input */}
      <input
        type="text"
        name="username"
        placeholder="Email"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        value={signinForm.values.username}
        onChange={signinForm.handleChange}
      />
      {signinForm.touched.username && signinForm.errors.username && (
        <p className="text-red-500 text-sm">{signinForm.errors.username}</p>
      )}

      {/* Password Input */}
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Password"
          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
          value={signinForm.values.password}
          onChange={signinForm.handleChange}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="
      absolute right-3 top-1/2 -translate-y-1/2
      text-gray-500 hover:text-yellowstar
      transition-colors
    "
        >
          {showPassword ? <EyeClosed size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {signinForm.touched.password && signinForm.errors.password && (
        <p className="text-red-500 text-sm">{signinForm.errors.password}</p>
      )}

      <div className="flex items-center my-16">
        <div className="flex-grow h-px bg-gray-200"></div>
      </div>

      {/* Sign In Button */}
      <button
        type="submit"
        className="w-full text-black hover:text-white py-2 rounded-md transition duration-300"
        disabled={isLoginRequest}
        style={{
          background: "linear-gradient(-45deg, #fed693, #ca7100)",
        }}
      >
        {isLoginRequest ? (
          <div className="flex justify-center gap-4 w-100 min-h-[30px] items-center">
            <ProcessingBar2 />
          </div>
        ) : (
          "Sign In"
        )}
      </button>

      {/* Divider */}
      <div className="flex items-center my-8">
        <div className="flex-grow h-px bg-gray-300"></div>
        <span className="px-4 text-sm text-textGray">
          Don't have account, please contact{" "}
          <a
            href="mailto:info@miraelte.com"
            className="text-yellowlight hover:underline"
          >
            Admin
          </a>
        </span>
        <div className="flex-grow h-px bg-gray-300"></div>
      </div>

      {/* Sign Up Link */}
      {/* <button
        type="button"
        onClick={() => switchAuthState()}
        className="w-full text-center text-yellow-500 hover:text-white mt-4 py-2 rounded-md border border-yellow-700"
      >
        Sign Up
      </button> */}

      {/* Error Message */}
      {errorMessage && (
        <p className="text-red-500 text-sm text-center">{errorMessage}</p>
      )}
    </form>
  );
};

export default SigninForm;
